
import { defineComponent, reactive, computed } from 'vue'

import CommonPageHeading from '@/components/common/CommonPageHeading.vue'

export default defineComponent({
  components: {
    CommonPageHeading
  },
  setup () {
    const works = computed(() => [
      {
        name: 'Portfolio Site',
        image: 'portfolio-site',
        link: 'https://github.com/taku-hu/portfolio-site',
        description: '私が初めて作ったもので、私のポートフォリオサイトです。\nコーディングに慣れるために、あえてほぼフルスクラッチで実装しました。\n最近Vue3 + compositionAPI + TypeScriptにリプレイスしました。'
      },
      {
        name: 'Tech Blog',
        image: 'blog',
        link: 'https://taku-hu-blog.netlify.app/',
        description: 'Nuxt + TypeScript + Tailwind + Contentfulで作ったブログです。\nSSGで開発しているため、PageSpeed Insightsの結果はモバイル99点・PC100点でした。'
      },
      {
        name: 'Online Bookshelf',
        image: 'bookshelf',
        link: 'https://book-manager-app-9ae82.firebaseapp.com/',
        description: '私が勉強したての時に初めて作ったウェブアプリケーションです。\nVue2 + GoogleBooksAPI + Firebaseで動いています。現在Vueの部分をReact + Hooks + TSXでリプレイス作業中。'
      },
      {
        name: 'Typing Game',
        image: 'typing-app',
        link: 'https://taku-hu.github.io/typing-app/',
        description: 'Vueの理解を深めるために作ったタイピングゲームです。\nJavaScript自体の理解も深めたいと思い、あえてフルスクラッチでより多くのコードを書きました。'
      }
    ])
    type Work = typeof works.value[number]

    const modal = reactive({
      data: {} as Work,
      isActive: false
    })
    const openModal = (work: Work) => {
      modal.data = work
      modal.isActive = true
    }
    const closeModal = () => modal.isActive = false

    return {
      works,
      modal,
      openModal,
      closeModal
    }
  }
})
